import React, { useState, createContext, useContext } from 'react';

import "./Accordion.css";

const AccordionContext = createContext();

export const Accordion = ({ children }) => {
    return <div className="accordion_container">{children}</div>;
};

const AccordionItem = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <AccordionContext.Provider value={{ isOpen, setIsOpen }}>
            <div className="accordion_item accordion_border mb-2">{children}</div>
        </AccordionContext.Provider>
    );
};

const AccordionHeader = ({ children }) => {
    const { isOpen, setIsOpen } = useContext(AccordionContext);
    const [icon, setICon] = useState("keyboard_arrow_up");

    const handlerIsOpen = () => {
        setIsOpen(!isOpen);
        setICon(isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down");
    };

    return (
        <div className="accordion_header p-2" onClick={handlerIsOpen}>
            {children}
            <span className="material-symbols-outlined keyboard_arrow">{icon}</span>
        </div>
    );
};

const AccordionBody = ({ children }) => {
    const { isOpen } = useContext(AccordionContext);

    return (
        isOpen && <div className="accordion_body accordion_border p-2">{children}</div>
    );
};

Accordion.Item = AccordionItem;
Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;

export default Accordion;